import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import UpdateForm from './UpdateForm'
import { PageHeader, StatusBadge } from '../../ui'

export default function PartnerReport() {

  const [lgShow, setLgShow] = useState(false);
  const [accessType, setAccessType] = useState('');

  //API call
  useEffect(() => {

    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);
    if (foundUser.role_capabilities?.all_modules_access === true) {

      setAccessType('Edit');

    }
    else {

      setAccessType(foundUser.access['Reservations_Access Specifier']);
    }

  }, []); 


  return (
    <>
      <PageHeader
        title="Partner Report"
        subtitle="Review partner reservation activity using account, location, vehicle, status, and date filters."
        eyebrow="Analytics"
        help={(
          <button type="button" className="btn btn-outline-primary" onClick={() => setLgShow(true)}>
            Help
          </button>
        )}
      >
        {accessType === 'View' && <StatusBadge status="neutral">View only</StatusBadge>}
      </PageHeader>

      <Modal
              size="lg"
              show={lgShow}
              onHide={() => setLgShow(false)}
              aria-labelledby="partner-report-help-title"

            >
              <Modal.Header closeButton>
                <Modal.Title id="partner-report-help-title" >
                  Instructions to view Reservations
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <ol>
                  <li>Select the  Account Name from the dropdown</li>
                  <li>Select the location name from the location name dropdown
                  </li>
                  <li>Slect the car class
                  </li>
                  <li>Filter the reservations based on Booked Date, DropOff Date and PickUpDate

                  </li>
                  <li>Filter the booking status by selecting All, Valid, Cancelled, No Show from the dropdown
                  </li>
                  <li>Select From Date To Date from the calendar and click on fetch
                  </li>
                </ol>

                <h5>Existing Reservations:
                </h5>
                <ul>
                  <li>To view the reservation details select Account Name Location Name and filtre based  on car class, booking status and the date range.

                  </li>
                </ul>

              </Modal.Body>
      </Modal>

      {accessType === 'View' ? <UpdateForm accessType={accessType} /> : <UpdateForm />}

    </>
  );
}
